import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-minimizer',
  templateUrl: './app-sidebar-minimizer.component.html'
})
export class AppSidebarMinimizerComponent { }



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.ts